import React, { useState } from 'react'
import { usePost } from './hooks/usePost'
import { RadBox } from './common/RadBox'
import { RadButton } from './common/RadButton'
import { RadCheckbox } from './common/RadCheckbox'
import { RadDivider } from './common/RadDivider'
import { RadFormField } from './common/RadFormField'
import { RadModal } from './common/RadModal'
import { RadSpaceBetween } from './common/RadSpaceBetween'
import { RadTextarea } from './common/RadTextarea'
import { isNullOrWhitespace } from './common/utilities'
import { RadIcon } from './common/RadIcon'
import './AskTheLibrarian.scss'

export function AskTheLibrarianButton () {
  const [showModal, setShowModal] = useState(false)
  return (
    <div className='ask-the-librarian'>
      <RadButton
        variant='link'
        onClick={() => setShowModal(!showModal)}
        className='ask-the-librarian-button'
      >
        <RadIcon size='medium' name='contact' />
      </RadButton>
      {showModal && <AskTheLibrarianModal dismiss={() => setShowModal(false)} />}
    </div>
  )
}

export function AskTheLibrarianModal ({ dismiss }) {
  const [formValues, setFormValues] = useState({})

  if (formValues != null) {
    return (
      <RadModal
        visible
        onDismiss={dismiss}
        closeAriaLabel='Close modal'
      >
        <RadSpaceBetween size='l'>
          <div className='header'>Got ideas?</div>
          <div className='subheader'>
            Contact us to turn your queries into action! Ask us for help using a feature, locating a resource, or even connecting with an interesting organization or project. Drop us a line to suggest resources to add to the database as well as improvements and fixes.
          </div>
          <AskQuestion formValues={formValues} setFormValues={setFormValues} dismiss={dismiss} />
        </RadSpaceBetween>
      </RadModal>
    )
  }
}

function AskQuestion ({ formValues, setFormValues, dismiss }) {
  const submitQuestion = usePost('/api/notification/ask-the-librarian', formValues, (resp) => dismiss())

  return (
    <RadSpaceBetween size='l'>
      <RadFormField label='Subject line' field='question' required>
        <RadTextarea
          rows={2}
          placeholder='What is this about?'
          value={formValues.question}
          onChange={({ detail }) => setFormValues({ ...formValues, question: detail.value })}
        />
      </RadFormField>
      <RadFormField label='More Detail / Explanation' field='detail'>
        <RadTextarea
          rows={2}
          placeholder={'Provide some specifics such as the page you\'re on or the type of resource you are looking for'}
          value={formValues.detail}
          onChange={({ detail }) => setFormValues({ ...formValues, detail: detail.value })}
        />
      </RadFormField>
      <RadCheckbox
        checked={formValues.confirm}
        onChange={({ detail }) => {
          setFormValues({ ...formValues, confirm: detail.checked })
        }}
      >
        Receive an email confirmation of your submission.
      </RadCheckbox>
      <RadBox>Fields marked with a <span style={{ color: 'red' }}>*</span> are required.</RadBox>

      <RadDivider />

      <RadBox float='right'>
        <RadSpaceBetween direction='horizontal' size='xxs'>
          <RadButton
            variant='link' onClick={() => {
              setFormValues({})
              dismiss()
            }}
          >
            Cancel
          </RadButton>
          <RadButton
            variant='primary'
            onClick={() => submitQuestion()}
            disabled={isNullOrWhitespace(formValues.question)}
          >
            Submit Question
          </RadButton>
        </RadSpaceBetween>
      </RadBox>
    </RadSpaceBetween>
  )
}
